import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class LayoutGap extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {

    const selectOptions = [];
    let suffix = "px";
    if (themeId !== undefined) {
      themeStructure.size.spacing.forEach(size => {
        let pxValue = BaseOption._getStyleValuePropertiesFromTheme("size.spacing", themeId)[size];
        if (pxValue) { // justin added the missing item into the theme but i need this for now
          if (!pxValue.endsWith("px")) {
            pxValue += "px";
          }

          selectOptions.push({
            value: size,
            label: camelToTitleCase(size),
            secondaryLabel: pxValue,
          });

          if (optionValues["default.layout-gap"] === size) {
            suffix = pxValue;
          }
        }
      });
    }

    return {
      label: "Gap",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        showAllResultsOnClick: true,
        allowCustomValue: true,
        items: selectOptions,
        itemValueKey: "value",
        itemLabelKey: "label",
        prefix: "G:",
        suffix: suffix,
      },
    };
  };

  static defaultValue = "standard";
}
